export function asString(value: unknown, fallback = ''): string {
   if (value == null) {
      return fallback;
   }

   const text = String(value).trim();
   return text || fallback;
}

export function asNumber(value: unknown, fallback = 0): number {
   if (value == null || value === '') {
      return fallback;
   }

   const parsed = Number(value);
   return Number.isFinite(parsed) ? parsed : fallback;
}

export function asArray<T>(value: unknown): T[] {
   return Array.isArray(value) ? (value as T[]) : [];
}

export function parseDate(value: unknown): Date {
   if (value instanceof Date) {
      return value;
   }

   if (value == null || value === '') {
      return new Date(Number.NaN);
   }

   return new Date(value as string | number);
}

export function isValidDate(value: Date | null | undefined): value is Date {
   return !!value && !Number.isNaN(value.getTime());
}
